import logUtil from 'utils/log'
import differenceInDaysDateUtil from 'utils/date/difference-in-days'

const MIN_DAYS_TO_SHOW_BANNER_AFTER_CLOSURE = 1

/**
 * @param props
 * @param props.shouldVisuallyShowMinimumToCheckOut
 * @param props.closedAtStr
 * @param props.isFreeSampleCollection
 * @param props.isSelfGifting
 * @param props.isMixedCollectionUrl
 * @returns {boolean}
 */
const shouldShowMinimumToCheckOutBannerCartSelectUtil = ({
  shouldVisuallyShowMinimumToCheckOut,
  closedAtStr,
  isFreeSampleCollection,
  isSelfGifting,
  isMixedCollectionUrl
}) => {
  const debugProps = {
    shouldVisuallyShowMinimumToCheckOut,
    closedAtStr,
    isFreeSampleCollection,
    isSelfGifting,
    isMixedCollectionUrl
  }
  logUtil('shouldShowMinimumToCheckOutBannerCartSelectUtil').debug('[start] debugProps=', debugProps)

  if (
    !isFreeSampleCollection &&
    !isSelfGifting &&
    !isMixedCollectionUrl
  ) {
    return false
  }

  if (!shouldVisuallyShowMinimumToCheckOut) {
    return false
  }

  if (!closedAtStr) {
    return shouldVisuallyShowMinimumToCheckOut
  }

  const closedAt = new Date(closedAtStr)
  const daysDiff = differenceInDaysDateUtil(
    new Date(),
    new Date(closedAt)
  )

  return (
    shouldVisuallyShowMinimumToCheckOut &&
    daysDiff >= MIN_DAYS_TO_SHOW_BANNER_AFTER_CLOSURE
  )
}

export default shouldShowMinimumToCheckOutBannerCartSelectUtil
